import '.d{display:flex;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.u{gap:0.5rem;}.ssr-plugin'
import '.b6{height:2.5rem;}.ssr-plugin'
import '.b7{justify-content:flex-end;}.ssr-plugin'
import '.ao{position:relative;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.a1{cursor:pointer;}.ssr-plugin'
import { MegaMenu } from '../../megaMenu/MegaMenu.desktop'
import { HoverTabs } from '@app/components/core/tabs/HoverTabs'
import { Image } from '@app/components/core/image/Image'
import { useTranslations } from '@i18n/useLanguage'
import { NavBarDesktop } from '../blocks/NavBar.desktop'
import { useTenantContext } from '@app/util/contexts/TenantContext'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Button } from '@app/components/core/button/Button'
import { Style, styled } from 'inlines'
import { useAuthModal } from '@app/util/hooks/useAuthModal'
import { pages } from '@app/util/links'
import { ProfileMenu } from '../blocks/ProfileMenu'
import { useLocation } from 'wouter'
import { authTabs } from '../../authentication/authTabs'

const ACCOUNT_SLOT_WIDTH = '14rem'
const ACCOUNT_APPEAR_ANIMATION = 'nav-account-appear 220ms ease-out'

const AuthButtons = () => {
  const { showAuthModal } = useAuthModal()
  const t = useTranslations().app.nav

  return (
    <div className="d t u"
    >
      <Button
        variant="secondary"
        label={t.logIn}
        onClick={() => showAuthModal(authTabs.login)}
        style={{ whiteSpace: 'nowrap' }}
      />
      <Button
        variant="primary"
        label={t.signUp}
        onClick={() => showAuthModal(authTabs.signUp)}
        style={{ whiteSpace: 'nowrap' }}
      />
    </div>
  )
}

type AccountSectionProps = {
  userName?: string
  avatar?: string
  isLoading?: boolean
}

const AccountSection = ({
  userName,
  avatar,
  isLoading,
}: AccountSectionProps) => {
  const [, navigate] = useLocation()

  if (isLoading) {
    return (
      <div className="b6" style={{ width: ACCOUNT_SLOT_WIDTH,}} />
    )
  }

  return (
    <div className="d b7"
      style={{
        width: ACCOUNT_SLOT_WIDTH,
        animation: ACCOUNT_APPEAR_ANIMATION,
      }}
    >
      {userName ? (
        <ProfileMenu>
          <div className="ao d e t a1"
          >
            <Avatar
              size="small"
              labelSource={userName}
              image={avatar}
              onClick={() => navigate(pages.dashboard)}
            />
          </div>
        </ProfileMenu>
      ) : (
        <AuthButtons />
      )}
    </div>
  )
}

export type TopNavBarProps = {
  userName?: string
  avatar?: string
  isLoading?: boolean
  navBarStyle?: Style
}

export const TopNavBar = ({
  userName,
  avatar,
  isLoading,
  navBarStyle,
}: TopNavBarProps) => {
  const translations = useTranslations().app.nav
  const tenant = useTenantContext()

  return (
    <NavBarDesktop
      logo={<Image src={tenant.logoUrl} alt={`${tenant.title} Logo`} />}
      style={navBarStyle}
    >
      <HoverTabs.Group>
        <HoverTabs.Tab label={translations.find}>
          <MegaMenu variant="find" />
        </HoverTabs.Tab>
        <HoverTabs.Tab label={translations.start}>
          <MegaMenu variant="start" />
        </HoverTabs.Tab>
        <HoverTabs.Tab label={translations.learn}>
          <MegaMenu variant="learn" />
        </HoverTabs.Tab>
        <HoverTabs.Tab label={translations.aboutUs}>
          <MegaMenu variant="aboutUs" />
        </HoverTabs.Tab>
      </HoverTabs.Group>

      <AccountSection
        userName={userName}
        avatar={avatar}
        isLoading={isLoading}
      />
    </NavBarDesktop>
  )
}
